(() => {
  if (window.__pbCityGuard) return;
  window.__pbCityGuard = true;

  const CONFIGURATOR_SELECTOR = '[data-pb-configurator][data-ready="1"]:not([hidden])';
  const CITY_SELECTOR = '[data-pb-city]';
  const CITY_ERROR_SELECTOR = '[data-pb-city-error]';
  const CITY_SUMMARY_SELECTOR = '[data-pb-city-summary]';
  const CART_BUTTON_SELECTOR = 'product-to-cart[form-child] [data-to-cart]';
  const LOADING_CLASS = '!loading';

  const singleConfigurator = () => {
    const roots = document.querySelectorAll(CONFIGURATOR_SELECTOR);
    return roots.length === 1 ? roots[0] : null;
  };

  const configuratorFor = (element) => {
    const section = element?.closest?.('.shopify-section');
    return section?.querySelector(CONFIGURATOR_SELECTOR) || singleConfigurator();
  };

  const releaseLoading = (button) => {
    if (!button) return;
    button.classList.remove(LOADING_CLASS);
    button.closest('product-to-cart')
      ?.querySelector('[data-to-cart]')
      ?.classList.remove(LOADING_CLASS);
  };

  const showCityError = (root, city) => {
    const cityError = root.querySelector(CITY_ERROR_SELECTOR);
    const citySummary = root.querySelector(CITY_SUMMARY_SELECTOR);

    if (cityError) cityError.hidden = false;
    if (citySummary) citySummary.textContent = 'Sin seleccionar';

    city.setAttribute('aria-invalid', 'true');
    city.focus({ preventScroll: true });
    city.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  const invalidCityContext = (element) => {
    const root = configuratorFor(element);
    const city = root?.querySelector(CITY_SELECTOR);

    if (!root || !city || city.value) return null;
    return { root, city };
  };

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const button = target.closest(CART_BUTTON_SELECTOR);
    if (!button) return;

    const context = invalidCityContext(button);
    if (!context) return;

    event.preventDefault();
    event.stopPropagation();
    releaseLoading(button);
    showCityError(context.root, context.city);
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    const context = invalidCityContext(form);
    if (!context) return;

    event.preventDefault();
    event.stopPropagation();
    releaseLoading(form.querySelector(CART_BUTTON_SELECTOR));
    showCityError(context.root, context.city);
  }, true);

  document.addEventListener('change', (event) => {
    const city = event.target;
    if (!(city instanceof HTMLSelectElement) || !city.matches(CITY_SELECTOR)) return;

    const root = city.closest('[data-pb-configurator]');
    const cityError = root?.querySelector(CITY_ERROR_SELECTOR);

    if (city.value) {
      city.removeAttribute('aria-invalid');
      if (cityError) cityError.hidden = true;
    }
  }, true);
})();
